/**
 * Join an API base URL and a relative HAL href with exactly one slash between them.
 *
 * Both sides vary: `curafidaApiBaseUrl` ends with a slash in some deployments and not in others
 * (compare `environment/de.curafida.app` with `environment/curafida.localhost`), and an href may or
 * may not start with one. Naive concatenation is therefore wrong on one deployment or the other.
 *
 * @param base - API base URL, typically `ApiService.urlSignal()`
 * @param path - relative href, HAL-discovered or a literal fallback
 */
export function joinUrl(base: string | undefined, path: string): string {
    if (!base) return path;
    return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}
